module.exports = __webpack_public_path__ + "img/bkk.24a4cc9a.svg";